import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);
  text-align: center;
`

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
`

const Description = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
`

const DeployButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: #0066ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;

  &:hover {
    background: #0052cc;
  }
`

export function EmptyState() {
  return (
    <Container>
      <Title>No Instances</Title>
      <Description>Deploy a new server at any of our worldwide datacenter locations.</Description>
      <DeployButton>Deploy Server</DeployButton>
    </Container>
  )
}

